export const FETCH_CONVERSATIONS_FULLFILLED = "FETCH_CONVERSATIONS_FULLFILLED",
    SUBSCRIBE_CONVERSATION = "SUBSCRIBE_CONVERSATION",
    RECEIVED_CONVERSATION_MESSAGE = "RECEIVED_CONVERSATION_MESSAGE",
    UNSUBSCRIBED_SESSION = 'UNSUBSCRIBED_SESSION',
    NEW_CONVERSATION = 'NEW_CONVERSATION',
    REMOVED_CONVERSATION = 'REMOVED_CONVERSATION',
    NOTIFY_READ = 'NOTIFY_READ',
    SESSION_UPDATED = 'SESSION_UPDATED',
    STOMP_CONNECTED = "STOMP_CONNECTED";

export const conversations = (state = {conversations: {}, subscriptions: {}, unread: {}, paused: []}, action = {}) => {
    switch (action.type) {
        case FETCH_CONVERSATIONS_FULLFILLED: {
            const conversations = action.conversations;
            return {
                ...state,
                conversations: conversations,
                unread: Object.keys(conversations).reduce((result, conversationId) => {
                    result[conversationId] = conversations[conversationId].map(message => message.id);
                    return result;
                }, {})
            };
        }
        case UNSUBSCRIBED_SESSION: {
            let result = {
                ...state,
            };
            delete result.subscriptions[action.id];
            return result;
        }
        case SUBSCRIBE_CONVERSATION: {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    [action.id]: action.subscription
                }
            }
        }

        case RECEIVED_CONVERSATION_MESSAGE: {
            return {
                ...state,
                conversations: {
                    ...state.conversations,
                    [action.id]: state.conversations[action.id].concat([action.message])
                },
                unread: {
                    ...state.unread,
                    [action.id]: (state.unread[action.id] || []).concat([action.message.id])
                }
            }
        }

        case NEW_CONVERSATION: {
            return {
                ...state,
                conversations: {
                    ...state.conversations,
                    [action.id]: []
                }
            }
        }

        case REMOVED_CONVERSATION: {
            let result = {
                ...state,
                conversations: {
                    ...state.conversations,
                }
            };
            delete result.conversations[action.id];
            return result;
        }

        case NOTIFY_READ: {
            return {
                ...state,
                unread: {
                    ...state.unread,
                    [action.conversationId]: state.unread[action.conversationId].filter(messageId => {
                        return action.messageIds.indexOf(messageId) < 0
                    })
                }
            };

        }

        case SESSION_UPDATED: {
            let updated = {
                ...state
            };

            if (action.response.botEnabled) {
                updated.paused = updated.paused.filter(id => id !== action.sessionId);
            } else {
                updated.paused = updated.paused.concat([action.sessionId]);
            }
            return updated;
        }

        case STOMP_CONNECTED: {
            return {
                ...state,
                stomp: true
            }
        }
        default:
            return state
    }

};






// WEBPACK FOOTER //
// ./src/reducers/conversations.js